var _rect, _rect2, _rect3, _g, _line, _rect4, _rect5, _rect6, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleTabDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 840,
    height: 40,
    viewBox: "0 0 840 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#347AF0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#347AF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4434_110040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.5301 11H54.9419C54.6871 10.9997 54.4349 11.0496 54.1994 11.1468C53.964 11.2441 53.75 11.3867 53.5696 11.5666C53.3893 11.7466 53.2462 11.9603 53.1485 12.1955C53.0507 12.4307 53.0003 12.6829 53 12.9376V27.0624C53.0006 27.5761 53.2049 28.0686 53.5681 28.4319C53.9314 28.7951 54.4239 28.9994 54.9376 29H65.5259C66.0396 28.9994 66.5321 28.7951 66.8954 28.4319C67.2586 28.0686 67.463 27.5761 67.4635 27.0624V12.9376C67.463 12.4247 67.2592 11.9328 66.8969 11.5696C66.5345 11.2065 66.0431 11.0017 65.5301 11ZM66.176 27.0624C66.176 27.2337 66.108 27.3979 65.9868 27.5191C65.8657 27.6402 65.7014 27.7082 65.5301 27.7082H54.9419C54.7706 27.7082 54.6063 27.6402 54.4852 27.5191C54.364 27.3979 54.296 27.2337 54.296 27.0624V12.9376C54.2963 12.7664 54.3644 12.6023 54.4855 12.4812C54.6065 12.3602 54.7707 12.292 54.9419 12.2918H65.5301C65.7014 12.2918 65.8657 12.3598 65.9868 12.4809C66.108 12.6021 66.176 12.7663 66.176 12.9376V27.0624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4316 15.5938H56.0352V16.8855H64.4316V15.5938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4316 19.082H56.0352V20.3738H64.4316V19.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4316 22.5703H56.0352V23.8621H64.4316V22.5703Z",
    fill: "white"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 96.0109,
    y1: 22.5423,
    x2: 743.982,
    y2: 16.458,
    stroke: "#51566D",
    strokeOpacity: 0.5,
    strokeDasharray: "5 5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 760.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 760.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#347AF0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 762,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#347AF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M775.001 14.9999H785.001V16.7899C785.001 17.2399 785.541 17.4599 785.851 17.1399L788.641 14.3499C788.841 14.1499 788.841 13.8399 788.641 13.6399L785.851 10.8499C785.541 10.5399 785.001 10.7599 785.001 11.2099V12.9999H774.001C773.451 12.9999 773.001 13.4499 773.001 13.9999V17.9999C773.001 18.5499 773.451 18.9999 774.001 18.9999C774.551 18.9999 775.001 18.5499 775.001 17.9999V14.9999ZM785.001 24.9999H775.001V23.2099C775.001 22.7599 774.461 22.5399 774.151 22.8599L771.361 25.6499C771.161 25.8499 771.161 26.1599 771.361 26.3599L774.151 29.1499C774.461 29.4599 775.001 29.2399 775.001 28.7899V26.9999H786.001C786.551 26.9999 787.001 26.5499 787.001 25.9999V21.9999C787.001 21.4499 786.551 20.9999 786.001 20.9999C785.451 20.9999 785.001 21.4499 785.001 21.9999V24.9999Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4434_110040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4678,
    height: 18,
    fill: "white",
    transform: "translate(53 11)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleTabDone);
export default __webpack_public_path__ + "static/media/scheduleTabDone.e8227196f2c8948340a534e8e62dec3e.svg";
export { ForwardRef as ReactComponent };